<template>
    <div class="color_select_overlay" v-if="isShow" :style=style v-clickoutside:action_ClickOutside="{}">
        <Item
            v-for="(hex, index) in palette" :key="index"
            :hex="hex"
            :index="index"
            :selectedHexString="selectedHexString"
            :usingCustomColor="hasCustomColor"
            @selectColor="selectColor"
        />
        <div class="other_color_picker relative" @click="action_ShowColorPicker" v-clickoutside:action_CloseColorPicker="{}">
            <div class="color_palette" :class="{'dark_selected': isDarkSelected, 'light_selected': isLightSelected}" :style="customBackgroundColor">
                <v-icon class="check_icon">mdi-check-bold</v-icon>
            </div>
            <div>다른 색상 선택</div>
            <div class="workcode_colorpicker">
                <ColorPicker v-if=isShowColorPicker ref="ColorPicker"
                    v-model="pickerHexString"
                    @updateHandleMouseEvent=updateHandleMouseEvent
                />
            </div>
        </div>
        <!-- <div class="other_color_picker">
            <div class="color_palette dark_selected">
                <v-icon class="check_icon">mdi-check-bold</v-icon>
            </div>
            <div>다른 색상 선택</div>
        </div>
        <div class="other_color_picker">
            <div class="color_palette light_selected">
                <v-icon class="check_icon">mdi-check-bold</v-icon>
            </div>
            <div>다른 색상 선택</div>
        </div> -->
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import { sheetState } from '../../../../../sheet-state'

import Item from './ColorPaletteItem.vue'
import ColorPicker from '../ColorPicker/ColorPicker.vue'

export default {
    components: { Item, ColorPicker },
    props: {
        isShow: Boolean,
        selectedCodeInfo: Object,
    },
    data() {
        return {
            sheetState,

            code: {},

            isShowColorPicker: false,
            pickerHexString: {hex: '#FF0000'},

            isHandleMouseEvent: false,
        }
    },
    watch: {
        'selectedCodeInfo.code': {
            deep: true,
            handler: function(newValue) {
                if (newValue == undefined) { this.code = {}; return }
                this.code = deepCopy(newValue)
            }
        },
        'pickerHexString.hex': {
            handler: function(newValue, oldValue) {
                if (newValue == oldValue) { return }
                this.code.customColorCode = newValue
                this.code.usingCustomColor = true
                this.updateValue()
            }
        }
    },
    computed: {
        reservationSetting: function() { return this.sheetState.reservationSetting },
        palette: function() { return this.reservationSetting.workCodeColorPaletteID?.basicPalette },
        selectedHexString: function() {
            if (this.usingCustomColor == true) { return this.customColorCode }
            return this.palette[this.paletteIndex]
        },
        style: function() { return 'top: ' + this.position.y + 'px; ' + 'left: 42px;' },
        paletteIndex: function() { return this.code?.paletteIndex },
        customColorCode: function() { return this.code?.customColorCode },
        position: function() { return this.selectedCodeInfo?.position },
        index: function() { return this.selectedCodeInfo?.index },
        hasCustomColor: function() { return this.code.usingCustomColor },
        brightness: function() {
            let color = this.customColorCode?.slice(1) ?? '#FF0000'
            let rgb = parseInt(color, 16) // 16진수를 10진수로 변환
            let r = (rgb >> 16) & 0xff
            let g = (rgb >> 8) & 0xff
            let b = (rgb >> 0) & 0xff
            return 0.299 * r + 0.587 * g + 0.114 * b // 밝기 계산
        },
        selectedStyle: function() {
            if (this.hasCustomColor == false) { return '' }
            return this.brightness < 111 ? 'dark_selected' : 'light_selected'
        },
        isDarkSelected: function() { return this.selectedStyle == 'dark_selected' },
        isLightSelected: function() { return this.selectedStyle == 'light_selected' },
        customBackgroundColor: function() { return 'background-color: ' + this.customColorCode + ';'}
    },
    methods: {
        action_ShowColorPicker() {
            this.isShowColorPicker = true
        },
        action_CloseColorPicker() {
            if (this.isHandleMouseEvent == true) { return }
            this.isShowColorPicker = false
        },
        action_ClickOutside() {
            if (this.isShow == false) { return }
            if (this.isHandleMouseEvent == true) { return }
            this.action_CloseColorPicker()
            this.$emit('closeColorPalette')
        },


        // MARK: - Emit
        selectColor(_, index) {
            this.code.customColorCode = undefined
            this.code.usingCustomColor = false
            this.code.paletteIndex = index
            this.updateValue()
        },
        updateHandleMouseEvent(isHandle) {
            this.isHandleMouseEvent = isHandle
        },
        updateValue() {
            this.$emit('updateValue', this.code, this.index)
        }
    }
}
</script>


<style scoped>
.workcode_colorpicker {
    position: absolute;
    top: 15px;
    left: 20px;
}
</style>